module.exports = __webpack_public_path__ + "static/media/JoinDiscord.e60f245c.svg";